import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./NotFound.scss";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found">
      <div className="container">
        <p className="code">404</p>
        <h1 className="title">{t("notFound.title")}</h1>
        <p className="message">{t("notFound.message")}</p>
        <Link to="/" className="back-home">
          {t("notFound.back")}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
